"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInput = void 0;
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const react_1 = require("react");
const utils_1 = require("../utils");
function useInput() {
    /**
     * Reference to filterbox input.
     */
    const inputRef = (0, react_1.useRef)(null);
    /**
     * Current width of input. Is synchronized with width of highlight div.
     *
     * See highlight-hook.tsx at line 21.
     */
    const [width, setWidth] = (0, react_1.useState)(0);
    /**
     * Current scroll position of filterbox input. Is synchronized with width of highlight div, to correctly position highlights.
     *
     * See highlight-hook.tsx at line 21.
     */
    const [inputScrollOffset, setInputScrollOffset] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        let resizer;
        if (inputRef.current) {
            resizer = new resize_observer_polyfill_1.default(() => {
                var _a, _b;
                setWidth((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0);
            });
            resizer.observe(inputRef.current);
        }
        return () => resizer.disconnect();
    }, []);
    (0, utils_1.useEventListener)({
        target: inputRef.current,
        types: ['scroll'],
        handler: () => {
            var _a, _b, _c;
            console.log((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft);
            setInputScrollOffset((_c = (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) !== null && _c !== void 0 ? _c : 0);
        },
        shouldRegister: true,
    });
    /**
     * Number of caret position. Used to correctly position suggestions.
     */
    const cursorPosition = (0, react_1.useRef)(0);
    return {
        inputRef,
        inputWidth: width,
        inputScrollOffset,
        cursorPosition,
    };
}
exports.useInput = useInput;
//# sourceMappingURL=input-hook.js.map